







import { Component, Vue, Prop, Inject } from 'nuxt-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class DynamicContainer extends Vue {
  @Prop({ type: [String, Object], default: 'div' })
  withContainer!: any

  @Prop({ type: [String, Object], default: 'div' })
  withoutContainer!: any

  @Inject({ default: false })
  skipContainer!: boolean

  get comp () {
    return this.skipContainer ? this.withoutContainer : this.withContainer;
  }

  get attrs () {
    const allAttrs = this.$attrs;
    const keyword = this.skipContainer ? 'with' : 'without';

    return Object.entries(allAttrs).reduce((obj, [key, value]) => {
      if (!key.startsWith(keyword))
        obj[key.replace(/^(with|without)-?/, '')] = value;

      return obj;
    }, {});
  }
}
